import ValidacaoServicosPrestadosMixin from "../../../shared/mixins/validation/ValidacaoServicosPrestadosMixin";
import ClinicaMixin from "../../CentroMultiprofissional.mixin";
import ServicosService from "./ServicosService";

export default {
  mixins: [ValidacaoServicosPrestadosMixin, ServicosService, ClinicaMixin],
  data() {
    return {
      objetoServicos: {
        "Tipo de Clínica": {
          id: null,
          ativo: false,
          preenchido: true,
          payload: {}
        },
        "Especialidades Médicas": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Centro de Oncologia": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Centro Multidisciplinar": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        Outros: { id: null, ativo: false, preenchido: false, payload: {} },
        "Centro de Terapias Especiais": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Centro de Hemodiálise": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Centro de Hemodinâmica": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Centro de Vacinação": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Espaço Viver Bem": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        },
        "Atenção Primária à Saúde": {
          id: null,
          ativo: false,
          preenchido: false,
          payload: {}
        }
      },

      payloadServicos: [],
      payloadEspecialidades: [],
      payloadAbrancencias: [],
      payloadServicosPublicos: [],

      dadosServidorServ: {
        servicos: [],
        abrangencias: [],
        especialidades: [],
        servicosPublicos: []
      },

      servicosAtivos: [
        "Centro Multidisciplinar",
        "Espaço Viver Bem",
        "Atenção Primária à Saúde",
        "Outros"
      ]
    };
  },
  beforeMount() {
    this.inicializarServicos().finally(() => {
      this.preencherDadosServidor();
    });
  },
  methods: {
    async inicializarServicos() {
      const { data } = await this.getServicos();

      if (!data) return;

      data.forEach(obj => {
        // A função trim está corrigindo um typo do backend no servico 'Serviço de Atenção Domiciliar'
        // Tem um espaço a mais no final
        this.objetoServicos[obj.tipoServico.trim()].id = obj.id;
        this.objetoServicos[obj.tipoServico.trim()].ativo = true;
        this.objetoServicos[
          obj.tipoServico.trim()
        ].ativo = this.servicosAtivos.includes(obj.tipoServico.trim())
          ? true
          : false;
      });
    },
    verificaNulo(texto) {
      return !!texto;
    },

    async preencherDadosServidor() {
      const payloadServidor = this.$store.getters.getPayloadServidor();

      if (payloadServidor) {
        this.dadosServidorServ = {
          servicos: payloadServidor.servicos,
          abrangencias: payloadServidor.abrangencias,
          especialidades: payloadServidor.especialidades,
          servicosPublicos: payloadServidor.servicosPublicos
        };
      }
    },

    formatarEspecialidades(data, especialidades) {
      let cadaEspecialidade;

      this.payloadEspecialidades = this.payloadEspecialidades.filter(
        e => e.tipoServico.id !== data[1].id
      );

      especialidades.forEach(el => {
        cadaEspecialidade = {
          idQuestionarioServicoEspecialidade: "",
          tipoServicoEspecialidade: {
            id: el.id,
            tipoServicoEspecialidade: el.tipoServicoEspecialidade
          },
          tipoServico: {
            id: data[1].id,
            tipoServico: data[0]
          }
        };

        const existe = this.payloadEspecialidades.find(
          esp => esp.tipoServicoEspecialidade.id === el.id
        );

        if (existe) return;

        this.payloadEspecialidades.push(cadaEspecialidade);
      });
    },
    formatarAbrangencias(data, abrangencia) {
      if (
        this.payloadAbrancencias.some(
          abrangenciaPayload =>
            abrangenciaPayload.tipoServicoAbrangencia.id == abrangencia.id
        )
      ) {
        return;
      }

      let tipoServicoAbrangencia;

      if (!abrangencia) {
        return;
      } else if (Object.keys(abrangencia).length < 1) {
        return;
      } else {
        tipoServicoAbrangencia = {
          id: abrangencia.id,
          tipoServicoAbrangencia: abrangencia.tipoServicoAbrangencia
        };
      }

      let cadaAbrangencia = {
        idQuestionarioServicoAbrangencia: "",
        tipoServico: {
          id: data[1].id,
          tipoServico: data[0]
        },
        tipoServicoAbrangencia
      };

      this.payloadAbrancencias.push(cadaAbrangencia);
    },
    formatarServicosPublicos(data, servPubl) {
      if (
        this.payloadServicosPublicos.some(
          servPublPayload =>
            servPublPayload.tipoServicoPublico.id == servPubl.id
        )
      ) {
        return;
      }

      let tipoServicoPublico;

      if (!servPubl) {
        return;
      } else if (Object.keys(servPubl).length < 1) {
        return;
      } else {
        tipoServicoPublico = {
          id: servPubl.id,
          tipoServicoPublico: servPubl.tipoServicoPublico
        };
      }

      let cadaServicoPublico = {
        idQuestionarioServicoPublico: "",
        tipoServico: {
          id: data[1].id,
          tipoServico: data[0]
        },
        tipoServicoPublico
      };

      this.payloadServicosPublicos.push(cadaServicoPublico);
    },
    preparaDadosServicos() {
      this.payloadServicos = [];
      let cadaServico = {};

      Object.entries(this.objetoServicos).forEach(servico => {
        if (!servico[1].ativo) return;
        if (!servico[1].preenchido) return;

        const { payload } = servico[1];
        let outro = "";
        let numeroLeitosObservacao = null;
        let especialidadesOferecidas = "";
        // let tipoServicoPublico = null;

        if (payload.tipoServicoEspecialidade) {
          this.formatarEspecialidades(
            servico,
            payload.tipoServicoEspecialidade
          );
        }

        if (
          servico[0] === "Serviço de Remoção" &&
          !payload.tipoServicoAbrangencia
        ) {
          this.formatarAbrangencias(servico, {});
        }
        if (
          Array.isArray(payload.tipoServicoAbrangencia) &&
          payload.tipoServicoAbrangencia
        ) {
          payload.tipoServicoAbrangencia.forEach(servAbrangencia =>
            this.formatarAbrangencias(servico, servAbrangencia)
          );
        }
        if (
          isObject(payload.tipoServicoAbrangencia) &&
          payload.tipoServicoAbrangencia
        ) {
          this.formatarAbrangencias(servico, payload.tipoServicoAbrangencia);
        }
        // if (
        //   Array.isArray(payload.tipoServicoPublico) &&
        //   payload.tipoServicoPublico.length > 0
        // ) {
        //   tipoServicoPublico = payload.tipoServicoPublico;
        // }
        // if (!payload.tipoServicoPublico) {
        //   tipoServicoPublico = null;
        // }
        // if (
        //   isObject(payload.tipoServicoPublico) &&
        //   payload.tipoServicoPublico
        // ) {
        //   tipoServicoPublico = {
        //     id: payload.tipoServicoPublico.id,
        //     tipoServicoPublico: payload.tipoServicoPublico.tipoServicoPublico
        //   };
        // }
        if (
          Array.isArray(payload.tipoServicoPublico) &&
          payload.tipoServicoPublico
        ) {
          payload.tipoServicoPublico.forEach(servPubl =>
            this.formatarServicosPublicos(servico, servPubl)
          );
        }
        if (
          isObject(payload.tipoServicoPublico) &&
          payload.tipoServicoPublico
        ) {
          this.formatarServicosPublicos(servico, payload.tipoServicoPublico);
        }

        if (payload.outro) outro = payload.outro;
        if (payload.numeroLeitosObservacao) {
          numeroLeitosObservacao = +payload.numeroLeitosObservacao || 0;
        }
        if (payload.especialidadesOferecidas) {
          especialidadesOferecidas = payload.especialidadesOferecidas;
        }

        cadaServico = {
          idQuestionarioServico: "",
          tipoServico: {
            id: servico[1].id,
            tipoServico: servico[0]
          },
          // tipoServicoPublico,
          especialidadesOferecidas,
          numeroLeitosObservacao,
          outro
        };

        this.payloadServicos.push(cadaServico);
      });

      this.$emit("payload-atualizado", {
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        abrangencias: this.payloadAbrancencias,
        servicosPublicos: this.payloadServicosPublicos
      });
    }
  }
};

const isObject = obj => {
  return Object.prototype.toString.call(obj) === "[object Object]";
};
